module.exports = __webpack_public_path__ + "img/n2.f1157b69.png";